import { Injectable } from "@angular/core";
import {
  CognitoUserAttribute,
  CognitoUserPool,
  ISignUpResult,
} from "amazon-cognito-identity-js";
import { Observable } from "rxjs";
import { CoreApiService } from "src/app/core/core-api.service";
import { endpoints } from "src/environments/endpoints";
import { environment } from "src/environments/environment";

import { ISignUpEmpresas, IUpdateEmpresas } from "../models/register.model";

@Injectable({
  providedIn: "root",
})
export class CadastroService {
  constructor(private apiService: CoreApiService) {}

  efetuarCadastro(obj) {
    return this.apiService.post(endpoints.cadastro, obj);
  }

  efetuarCadastroEmpresas(obj: ISignUpEmpresas) {
    return this.apiService.post(endpoints.cadastroEmpresa, obj);
  }

  validateEmail(params = {}) {
    return this.apiService.get(endpoints.validateEmail, { params });
  }

  editarDadosEmpresa(obj: IUpdateEmpresas) {
    return this.apiService.put(endpoints.atualizarDadosEmpresa, obj);
  }
}
